import {
  numberComparisonModes,
  showAllComparisonMode,
} from '../utils/comparison-mode-options'
import { comparisonModes, filters } from '../constants'
import {
  getComparisonLabel,
  normalizeSettingsForShowAll,
  workflowFilterLabel,
} from './shared'

export const workflowProgressDefinition = {
  type: filters.WORKFLOW_PROGRESS,
  nameKey: 'workflow_progress',
  ledgerRequired: true,
  hasModalHelp: true,

  comparisonModes() {
    return [...numberComparisonModes(), ...showAllComparisonMode()]
  },

  activeSubtitle(settings, getters) {
    const { comparisonMode, comparisonValue } = settings
    const comparisonLabel = getComparisonLabel(
      comparisonMode,
      this.comparisonModes()
    )

    const workflowLabel = workflowFilterLabel(settings, getters)

    if (comparisonMode === comparisonModes.SHOW_ALL) {
      return `${workflowLabel}`
    } else {
      return `${workflowLabel} ${comparisonLabel} ${comparisonValue || ''}`
    }
  },

  normalizeSettings(settings) {
    return normalizeSettingsForShowAll(settings, 'comparisonValue')
  },

  serializeSettings(settings) {
    return {
      firm_workflow_id: settings.firmWorkflowId,
      partner_workflow_id: settings.partnerWorkflowId,
      comparison_mode: settings.comparisonMode,
      comparison_value: settings.comparisonValue,
    }
  },

  deserializeSettings(params) {
    return {
      firmWorkflowId: params.firm_workflow_id,
      partnerWorkflowId: params.partner_workflow_id,
      comparisonMode: params.comparison_mode,
      comparisonValue: params.comparison_value,
    }
  },
}
